export const ACTION_TYPES = {
  GET_EKYC_OPTIONS: Symbol("GET_EKYC_OPTIONS"),
  SET_EKYC_OPTIONS: Symbol("SET_EKYC_OPTIONS"),
  POST_CREATE_EKYC: Symbol("POST_CREATE_EKYC"),
  SET_CREATE_EKYC_STATE: Symbol("SET_CREATE_EKYC_STATE"),
  GET_STOCK_CODE_OPTIONS: Symbol("GET_STOCK_CODE_OPTIONS"),
  SET_STOCK_CODE_OPTIONS: Symbol("SET_STOCK_CODE_OPTIONS"),
};
